/**
 * @generated SignedSource<<51273c5b58674810635188858c8a1c45>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Recurring",
    "kind": "LinkedField",
    "name": "updateRecurringPool",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Pool",
        "kind": "LinkedField",
        "name": "pool",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "paymentOptionsRecurringMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "paymentOptionsRecurringMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e1c7c028346aab237076881298a45533",
    "id": null,
    "metadata": {},
    "name": "paymentOptionsRecurringMutation",
    "operationKind": "mutation",
    "text": "mutation paymentOptionsRecurringMutation(\n  $request: UpdateRecurringPoolRequestInput!\n) {\n  updateRecurringPool(request: $request) {\n    id\n    pool {\n      id\n    }\n    version\n  }\n}\n"
  }
};
})();

node.hash = "247855b6252a7d5c57202286d9e67196";

module.exports = node;
